import React, { useEffect, useState } from "react";
import InputText from "../../../components/input/inputText";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import Navigation from "../../../components/navigation";
import SecondScreen from "../../SecondScreen";
import { navigationStep } from "../../../redux/slices/navigation";
import { preloaderToggle } from "../../../redux/slices/preloader";
import StepCustomize from "../../../components/stepCustomize";
import { GetQrLink } from "../../../redux/requests/link";
import QrTitleField from "../../../components/input/qrTitleField";
import axios from "axios";
import { isNoEditRoute } from "../../../hooks/helpers";
import { setCategory } from "../../../redux/slices/selectCategories";
import Form from "react-bootstrap/Form";
import { SelectCategory } from "../../../components";
import useIsNoIframe from "../../../hooks/useIsNoIframe";
import useGetDataError from "../../../hooks/useGetDataError";
import useCurrentLocation from "../../../hooks/useCurrentLocation";
import { saveValueLink } from "../../../redux/slices/saveValue";
import { QrUpi, QrUpiEdit } from "../../../redux/requests/upi";

function UpiWrapper({ children }) {
  const {
    lang,
    getQrLinkSliceId,
    categoryChange,
    getQrLinkSliceLink,
  } = useSelector((state) => ({
    lang: state.changeLang.language.stepTwo.upi,
    categoryChange: state.categories.categoryChange,
    type: state.typeCard.type,

  }));

  const { id } = useParams();

  useEffect(() => {
    setType("54");
  }, []);
  const dispatch = useDispatch();
  let navigate = useNavigate();
  const { isNoIframe, goToLink } = useIsNoIframe();
  const { checkErrorStatus } = useGetDataError();
  const { adminEntryLocation } = useCurrentLocation();
  const [upiId, setUpiId] = useState("");
  const [name, setName] = useState("");
  const [qrTitle, setQrTitle] = useState("");
  const [currencyId, setCurrencyId] = useState("17");
  const [amount, setAmount] = useState("");
  const [comment, setComment] = useState("");
  const [type, setType] = useState("54");
  const [empty, setEmpty] = useState(false);
  const [error, setError] = useState("");
  const [errorAmount, setErrorAmount] = useState("");
  useEffect(() => {
    if (id) {
      axios
        .get(`/entry/upi/get/${id}`)
        .then(({ data }) => {
          console.log(data);
          setQrTitle(data.qrTitle);
          setUpiId(data[0]?.upiId);
          setName(data[0]?.name);
          setAmount(data[0]?.amount);
          setComment(data[0]?.comment);
          dispatch(setCategory(data.adsCategories));
        })
        .catch((err) => {
          checkErrorStatus(err.response.status);
        });
    }
  }, [id]);


  function step() {
    if (upiId?.length !== 0) {
      setEmpty(false);
      dispatch(preloaderToggle(true));
      if (!getQrLinkSliceId && !id) {
        dispatch(
          GetQrLink(() =>
            QrUpi([qrTitle, upiId, name, currencyId, amount, comment, type, categoryChange])
          )
        );
      } else {
        dispatch(
          GetQrLink(() =>
            QrUpiEdit([
              getQrLinkSliceId || id,
              qrTitle, upiId, name, currencyId, amount, comment, type, categoryChange
            ])
          )
        ).then(() => {
          if (!isNoEditRoute) {
            window.location.href = adminEntryLocation;
          }
        });
      }

      if (isNoEditRoute) {
        dispatch(navigationStep(3));
        dispatch(saveValueLink([qrTitle, upiId]));
        isNoIframe && navigate("/qr");
      } else {
        dispatch(preloaderToggle(true));
      }
    } else {
      setEmpty(true);
    }
  }


  useEffect(() => {
    if (!isNoIframe && getQrLinkSliceLink) {
      goToLink();
    }
  }, [getQrLinkSliceLink]);
  const handleChangeUpiId = (e) => {
    const inputValue = e.target.value;
    const isValidUpi = /^[^@]+@[^@]+$/.test(inputValue);

    setUpiId(inputValue);

    if (!isValidUpi) {
      setError(lang[0]);
    } else {
      setError("");
    }
  };
  const handleChangeUpiAmount = (e) => {
    const inputValueAmount = e.target.value;
    const numericValue = parseFloat(inputValueAmount);

    setAmount(inputValueAmount);

    if (!numericValue || numericValue <= 0) {
      setErrorAmount(lang[7]);
    } else {
      setErrorAmount("");
    }
  };

  return (
    <>
      <Navigation />
      <SecondScreen>
        <Form className="col-12 col-lg-6 mx-auto my-3 ">
          <InputText
            type="text"
            placeholder={lang[1]}
            value={upiId}
            onChange={handleChangeUpiId}
          />
          {empty && upiId?.length === 0 && (
          <Form.Text className="text-danger">{lang[2]}</Form.Text>
        )}
          {error && <div className="text-danger">{error}</div>}
        </Form>
        <div className="col-12 col-lg-6 mx-auto mb-3">
          <p className="fw-bold">{lang[3]}</p>
          <div className="form-check mb-2">
            <input
              className="form-check-input"
              type="radio"
              name="upi"
              id="upi"
              checked={currencyId === "17"}
              onChange={() => setCurrencyId("17")}
            />
            <label className="form-check-label" htmlFor="upi">
              INR
            </label>
          </div>

        </div>
        <Form className="col-12 col-lg-6 mx-auto mb-3">
          <InputText
            type="text"
            placeholder={lang[4]}
            value={name}
            onChange={(e) => setName(e.target.value)}
          />
          {empty && name?.length === 0 && (
            <Form.Text className="text-danger">{lang[2]}</Form.Text>
          )}
        </Form>
        <Form className="col-12 col-lg-6 mx-auto mb-3">
          <InputText
            type="number"
            placeholder={lang[5]}
            value={amount}
            onChange={handleChangeUpiAmount}
          />
          {errorAmount && <div className="text-danger">{errorAmount}</div>}

        </Form>
        <Form className="col-12 col-lg-6 mx-auto mb-4">
          <InputText
            type="text"
            placeholder={lang[6]}
            value={comment}
            onChange={(e) => setComment(e.target.value)}
          />

        </Form>
        <Form className="col-12 col-lg-6 mx-auto mb-3">
          <QrTitleField
            value={qrTitle}
            onChange={(e) => setQrTitle(e.target.value)}
          />
        </Form>
        <SelectCategory />
        <StepCustomize
          emulate={step}
          disabled={
          upiId?.length === 0 || name?.length === 0 || amount?.length === 0 || Number(amount) === 0
          }
        />
      </SecondScreen>
      {isNoIframe && isNoEditRoute && children}
    </>
  );
}

export default UpiWrapper;